document.addEventListener('DOMContentLoaded',()=>{

  const cards =
    document.querySelectorAll('.asia24-card');

  cards.forEach((card,index)=>{

    card.animate(
      [
        {
          transform:'translateY(0px)'
        },
        {
          transform:'translateY(-12px)'
        },
        {
          transform:'translateY(0px)'
        }
      ],
      {
        duration:4000 + (index * 800),
        iterations:Infinity
      }
    );

  });

});